export default __webpack_public_path__ + "static/media/dimitar.8ee28d34.jpg";